import { listAllFiles } from "../utils/firebase";

const file = {
  state: {
    filesList: [],
    selectedFolder: "",
    history: {
      currentIndex: 0,
      steps: [{ action: "folderChange", path: "/uploads/" }],
    },
    selectedFiles: [],
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
    setHistoryIndex(state, index) {
      const history = state.history;
      history.currentIndex = index;
      state.history = history;
      return { ...state };
    },
    unsetSelectedFiles(state, payload) {
      return { ...state, selectedFiles: [] };
    },
    setSelectedFolder(state, payload) {
      let newHistory = { ...state.history };
      if (!payload.history) {
        newHistory.steps.push({
          action: "folderChange",
          path: payload.path,
        });
        newHistory.currentIndex =
          newHistory.steps.length === 0 ? 0 : newHistory.steps.length - 1;
      }
      return { ...state, history: newHistory, selectedFolder: payload.path };
    },
  },
  effects: {
    async getFilesList(payload, rootState) {
      const files = await listAllFiles({
        serviceCode: "866dd206-e2be-415e-8600-4fc3f63c9829",
        folder: "",
      });
      this.setState({
        filesList: files,
      });
    },
  },
};
export default file;
